/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Minimum_LabelInputs */

const et_plan_minimum_label = /** @type {(inputs: Plan_Minimum_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miinimum`)
};

const en_plan_minimum_label = /** @type {(inputs: Plan_Minimum_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum`)
};

/**
* | output |
* | --- |
* | "Minimum" |
*
* @param {Plan_Minimum_LabelInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_minimum_label = /** @type {((inputs?: Plan_Minimum_LabelInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Minimum_LabelInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_minimum_label(inputs)
	return en_plan_minimum_label(inputs)
});